var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChart1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.2339C1 12.4583 1.62872 11.8296 2.40426 11.8296H5.21279C5.98834 11.8296 6.61705 12.4583 6.61705 13.2339V20.2552C6.61705 21.0307 5.98834 21.6594 5.21279 21.6594H2.40426C1.62872 21.6594 1 21.0307 1 20.2552V13.2339Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95703 7.61688C8.95703 6.84133 9.58575 6.21262 10.3613 6.21262H13.1698C13.9454 6.21262 14.5741 6.84133 14.5741 7.61688V20.2553C14.5741 21.0308 13.9454 21.6595 13.1698 21.6595H10.3613C9.58575 21.6595 8.95703 21.0308 8.95703 20.2553V7.61688Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3825 3.40426C17.3825 2.62872 18.0112 2 18.7867 2H21.5953C22.3708 2 22.9995 2.62872 22.9995 3.40426V20.2554C22.9995 21.031 22.3708 21.6597 21.5953 21.6597H18.7867C18.0112 21.6597 17.3825 21.031 17.3825 20.2554V3.40426Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChart1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Chart1.0f4c543e7641a38fafa5d5d8046b0c35.svg";